import BusinessAdhocReporting from './BusinessAdhocReporting';

export default BusinessAdhocReporting;
